module.exports = __webpack_public_path__ + "static/media/IC_org.e1c9b405.svg";